import { render, staticRenderFns } from "./gameResultChangesLogTab.vue?vue&type=template&id=6634420b&lang=pug"
import script from "./gameResultChangesLogTab.vue?vue&type=script&lang=js"
export * from "./gameResultChangesLogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports